module.exports = __webpack_public_path__ + "img/20240201080704295j7x.34d400ff.jpg";